import React, { ReactNode } from 'react';
import {
  Box, Flex, Text, useColorModeValue,
} from '@chakra-ui/react';
import { useAppearance } from '../../theme/AppearanceProvider';
import useGlassPanel from '../../theme/glassPanel';

// A glass dashboard tile (Aurora) / flat panel (Accountant) with an optional
// label header and brand-accent top edge. The non-StatCard dashboard cards
// (Top Customers, Recent Activity, skeletons) sit in this so they match the
// StatCard surface exactly.
interface DashPanelProps {
  label?: string;
  accent?: string;
  right?: ReactNode;
  children: ReactNode;
}

const DashPanel: React.FC<DashPanelProps> = ({
  label, accent = 'brandGreen.400', right, children,
}) => {
  const { aurora } = useAppearance();
  const glass = useGlassPanel(); // item 406 — the ONE glass material
  const labelColor = useColorModeValue('gray.500', 'whiteAlpha.700');
  const accentVar = `var(--chakra-colors-${accent.replace('.', '-')})`;

  return (
    <Flex
      {...glass}
      direction="column"
      position="relative"
      overflow="hidden"
      h="full"
      p={6}
    >
      {aurora && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          h="3px"
          bgGradient={`linear(to-r, transparent, ${accent}, transparent)`}
          boxShadow={`0 0 14px ${accentVar}`}
        />
      )}
      {(label || right) && (
        <Flex align="center" justify="space-between" mb={4}>
          <Text fontSize="xs" fontWeight="bold" letterSpacing="0.14em" textTransform="uppercase" color={aurora ? labelColor : 'ledgerMuted'}>
            {label}
          </Text>
          {right}
        </Flex>
      )}
      {children}
    </Flex>
  );
};

DashPanel.defaultProps = {
  label: undefined,
  accent: 'brandGreen.400',
  right: undefined,
};

export default DashPanel;
